/* tslint:disable */
/* eslint-disable */
/**
 * BloomRegistration.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ClassSession,
    ClassSessionFromJSON,
    ClassSessionFromJSONTyped,
    ClassSessionToJSON,
} from './ClassSession';
import {
    Student,
    StudentFromJSON,
    StudentFromJSONTyped,
    StudentToJSON,
} from './Student';

/**
 * 
 * @export
 * @interface ClassSessionWaitlistSubmission
 */
export interface ClassSessionWaitlistSubmission {
    /**
     * 
     * @type {string}
     * @memberof ClassSessionWaitlistSubmission
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClassSessionWaitlistSubmission
     */
    classSessionId?: string | null;
    /**
     * 
     * @type {ClassSession}
     * @memberof ClassSessionWaitlistSubmission
     */
    classSession?: ClassSession;
    /**
     * 
     * @type {string}
     * @memberof ClassSessionWaitlistSubmission
     */
    studentId?: string | null;
    /**
     * 
     * @type {Student}
     * @memberof ClassSessionWaitlistSubmission
     */
    student?: Student;
    /**
     * 
     * @type {number}
     * @memberof ClassSessionWaitlistSubmission
     */
    status?: number;
    /**
     * 
     * @type {Date}
     * @memberof ClassSessionWaitlistSubmission
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClassSessionWaitlistSubmission
     */
    expires?: Date;
}

export function ClassSessionWaitlistSubmissionFromJSON(json: any): ClassSessionWaitlistSubmission {
    return ClassSessionWaitlistSubmissionFromJSONTyped(json, false);
}

export function ClassSessionWaitlistSubmissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassSessionWaitlistSubmission {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'classSessionId': !exists(json, 'classSessionId') ? undefined : json['classSessionId'],
        'classSession': !exists(json, 'classSession') ? undefined : ClassSessionFromJSON(json['classSession']),
        'studentId': !exists(json, 'studentId') ? undefined : json['studentId'],
        'student': !exists(json, 'student') ? undefined : StudentFromJSON(json['student']),
        'status': !exists(json, 'status') ? undefined : json['status'],
        'created': !exists(json, 'created') ? undefined : (new Date(json['created'])),
        'expires': !exists(json, 'expires') ? undefined : (new Date(json['expires'])),
    };
}

export function ClassSessionWaitlistSubmissionToJSON(value?: ClassSessionWaitlistSubmission | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'classSessionId': value.classSessionId,
        'classSession': ClassSessionToJSON(value.classSession),
        'studentId': value.studentId,
        'student': StudentToJSON(value.student),
        'status': value.status,
        'created': value.created === undefined ? undefined : (value.created.toISOString()),
        'expires': value.expires === undefined ? undefined : (value.expires.toISOString()),
    };
}

